/** Evento para sincronizar header tras login/logout de miembro (misma pestaña). */
export const JAVILAND_MEMBER_AUTH_EVENT = 'javiland-member-auth';

export function notifyMemberSessionChanged() {
  window.dispatchEvent(new CustomEvent(JAVILAND_MEMBER_AUTH_EVENT));
}

export function readMemberFromStorage() {
  try {
    const token = localStorage.getItem('javiland_member_token');
    const raw = localStorage.getItem('javiland_member_user');
    if (!token || !raw) return null;
    const user = JSON.parse(raw);
    return user && typeof user === 'object' ? user : null;
  } catch {
    return null;
  }
}

/** Iniciales para avatar (ej. Javier Gómez → JL). */
export function getMemberInitials(user) {
  if (!user || typeof user !== 'object') return 'JV';
  const fn = String(user.first_name || '').trim();
  const fl = String(user.first_last_name || '').trim();
  if (fn && fl) return (fn[0] + fl[0]).toUpperCase();
  const full = String(user.name || '').trim();
  if (full) {
    const parts = full.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    if (parts[0]) return parts[0].slice(0, 2).toUpperCase();
  }
  const em = user.email;
  if (em && typeof em === 'string') {
    const local = em.split('@')[0] || '';
    if (local.length >= 2) return local.slice(0, 2).toUpperCase();
    if (local) return local[0].toUpperCase();
  }
  return 'JV';
}

/** Nombre completo para mostrar en header / menú cuenta. */
export function getMemberDisplayName(user) {
  if (!user || typeof user !== 'object') return '';
  const fn = getMemberFirstName(user);
  const fl = String(user.first_last_name || '').trim();
  const sl = String(user.second_last_name || '').trim();
  const full = [fn, fl, sl].filter(Boolean).join(' ').trim();
  if (full) return full;
  return String(user.name || user.email || '').trim();
}

/** Primer nombre para el header: `first_name` guardado o primera palabra de `name` o prefijo del email. */
export function getMemberFirstName(user) {
  if (!user || typeof user !== 'object') return '';
  const direct = String(user.first_name || '').trim();
  if (direct) return direct;
  const full = String(user.name || '').trim();
  if (full) {
    const part = full.split(/\s+/).filter(Boolean)[0];
    if (part) return part;
  }
  const em = user.email;
  if (em && typeof em === 'string') {
    const local = em.split('@')[0];
    if (local) return local;
  }
  return '';
}

/** Tras login/OTP el API puede no enviar `first_name`; lo deducimos del nombre completo. */
export function enrichMemberFromApi(member) {
  if (!member || typeof member !== 'object') return {};
  const out = { ...member };
  if (!String(out.first_name || '').trim() && out.name) {
    const w = String(out.name).trim().split(/\s+/).filter(Boolean)[0];
    if (w) out.first_name = w;
  }
  return out;
}

export function clearMemberSession() {
  localStorage.removeItem('javiland_member_token');
  localStorage.removeItem('javiland_member_user');
  notifyMemberSessionChanged();
}

/** Actualiza el objeto usuario en localStorage (tras guardar perfil). */
export function persistMemberUser(user) {
  if (!user || typeof user !== 'object') return;
  try {
    localStorage.setItem('javiland_member_user', JSON.stringify(user));
    notifyMemberSessionChanged();
  } catch (e) {
    console.warn('persistMemberUser', e);
  }
}
